<template>
  <table>
     <tr v-for="ch in thisq.choices" :key="ch.id">
        <td v-if="((thisq.type == 'SEL') || (thisq.type == 'MAT'))" style="max-width:500px;padding: 3px 40px 3px 0px;" v-html="ch.text"></td> 

        <td v-if="thisq.type == 'SEL'" style="padding-right:25px;" >
           <select size="1" v-model="ch.selected">
           <option v-for="(alt,ix) in ch.alternatives" :value="ix" :key="ix">{{alt.text}}</option>
           </select>
        </td>

        <td v-if="thisq.type == 'MAT'" >
            <span v-for="(alt,ix) in ch.alternatives" :key="ix"> 
               <input type="radio" :value="ix" v-model="ch.selected" :id="ch.id + '_' + ix" >
               <label :for="ch.id + '_' + ix" style="padding-right:25px;" v-html="alt.text"></label>
            </span>
        </td>

        <td v-if="((thisq.type == 'SEL') || (thisq.type == 'MAT')) && (ch.selected != null)" style="vertical-align:center;padding: 5px 25px 5px 15px;min-width:500px;" :class="ch.alternatives[ch.selected].correct ? 'vpright' : 'vpwrong'" v-html="ch.alternatives[ch.selected].feedback"></td>


        <td v-if="((thisq.type == 'MC') || (thisq.type == 'MR'))" style="padding: 3px 0px 3px 0px;">
            <input v-if="thisq.type == 'MR'" type="checkbox" :id="ch.id" v-on:change="checked(ch.id,ch.correct)" :checked="thisq.selected.includes(ch.id.split('_').pop())">
            <input v-if="thisq.type == 'MC'" type="radio" :id="ch.id" v-on:click="checked(ch.id,ch.correct)" :checked="thisq.selected.includes(ch.id.split('_').pop())" :disabled="tryonce && thisq.tainted">

            <label class="labelclass" :for="ch.id"   v-html="ch.text"></label>
            
            <p v-show="((enbloc && showscore) || !enbloc) && thisq.selected.includes(ch.id.split('_').pop())" style="margin-left:25px;min-width:500px;" :class="ch.correct ? 'vpright' : 'vpwrong'" v-html="ch.feedback" ></p>
        </td>
        
     </tr>
  </table>
</template>

<script>
   import ajaxmixin from './ajaxmixin.vue'

   export default {

      name: 'mcq',

      mixins: [ajaxmixin],

      props: {
        thisq: Object,
        tryonce: Boolean,
        record: Boolean,
        enbloc: Boolean,
        showscore: Boolean,
        token: String
      },

      methods: {
         checked: function(cid,correct) {
    	    let id = cid.split('_').pop();       
            if ((this.thisq.type == 'MC') && (this.record && !this.thisq.tainted)) {
   	       let ids = cid.split('_');
   	       let answer = [id, "", correct.toString()].join('\x1f')
   
               // save result by means of vp-rails, not node
   
               if (true) {
   	          let resultat = {
   	             qmid: Number(ids[0]),
   	             qlid: Number(ids[1]),
   	             revision: Number(ids[2]),
   	             answer: answer,
   	             ip: "",
   	             respondent: (window.hasOwnProperty('surveyid') ? window.surveyid : '')
   	          }
                  this.ajaxtalk(resultat,'/vp/saveresult','POST', null, this.token);
               }
               else {
                  let tid = new Date();
                  let stid = tid.toISOString().substring(0,19);	
   	          let resultat = {
   	             qmid: ids[0],
   	             qlid: ids[1],
   	             revision: ids[2],
   	             answer: answer,
                     tid: stid,
   	             ip: "",
   	             uname: (window.hasOwnProperty('surveyid') ? window.surveyid : '')
   	          }
   	   
               //   if ((typeof socket === undefined) || (socket === undefined)) {
               //      let socket = io.connect('http://studmed.uio.no:4172');
   	       //   }
   	       //   if (socket.disconnected) {
               //      socket.open();
               //   }
               //   socket.on('connect', function() {
               //      socket.emit('resultat',resultat);
               //   })
               }
            }
   
            if ((!this.thisq.tainted) || (!this.tryonce)) {
               if (this.thisq.type == 'MC') {
                  this.thisq.selected = [id];
               }
   	       else if (this.thisq.type == 'MR') {
                  let i = this.thisq.selected.indexOf(id);
                  if (i == -1) {
   	             this.thisq.selected.push(id);
                  }
                  else {
   	             this.thisq.selected.splice(i,1);
                  }
               }
   	       this.thisq.tainted = true;
            }
         }
      }
   }

</script>

<style>
   .vpright {
      padding: 10px;
      margin: 8px 0px 8px 0px;
      background: #bde273;
   }

   .vpwrong {
      padding: 10px;
      margin: 8px 0px 8px 0px;
      background: #fde3e8;
   }

   .labelclass {
      margin-right: 10px;
   }

   .questionclass {
      margin: 10px 0px 10px 0px;
      font-weight: bold;
   }

</style>



